import t from"./AxiosError.js";function s(s,a,o){const e=o.config.validateStatus;o.status&&e&&!e(o.status)?a(new t("Request failed with status code "+o.status,[t.ERR_BAD_REQUEST,t.ERR_BAD_RESPONSE][Math.floor(o.status/100)-4],o.config,o.request,o)):s(o)}export{s as default};
//# sourceMappingURL=settle.js.map
